import { territoryRemoteLookupValidators } from "@schemas/remoteLookup/territoryRemoteLookupSchema";
import type {
  TerritoryRemoteLookupId,
  TerritoryRemoteLookupItem,
  TerritoryRemoteLookupFilters,
} from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const territoryProvider: RemoteLookupProvider<
  TerritoryRemoteLookupId,
  TerritoryRemoteLookupItem,
  TerritoryRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: territoryRemoteLookupValidators,
};
